export default {"src":"/_next/static/media/whale.cbcd651b.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};